import { CrudState } from "@/store/Crud/State";
export class State extends CrudState {
  checkListDataItem: Record<string, any> = {};
}
